export const getDeviceInfo = () => {
  const ua = navigator.userAgent;
  const info = {
    os: "unknown",
    device: "unknown",
    mobile: /Android|iPhone|iPad|iPod|Windows Phone/i.test(ua) ? 1 : 0,
  };

  if (/Android/i.test(ua)) {
    info.os = "Android";
    info.device = "Android";
  }
  if (/iPhone|iPad|iPod/i.test(ua)) info.os = "iOS";
  if (/Windows/i.test(ua)) info.os = "Windows";
  if (/Macintosh|Mac OS X/i.test(ua)) info.os = "macOS";
  if (/Linux/i.test(ua)) info.os = "Linux";
  if (/iPhone/i.test(ua)) info.device = "iPhone";
  if (/iPad/i.test(ua)) info.device = "iPad";

  return info;
};
